import { isObservable, makeAutoObservable } from "mobx";
var makeDefaultPaginationState = function () { return ({
    currentPage: 1,
    perPage: 15,
    totalItems: 0,
}); };
var BasePaginationState = /** @class */ (function () {
    function BasePaginationState(options) {
        this.options = makeDefaultPaginationState();
        if (options && isObservable(options)) {
            this.options = options;
        }
        else {
            Object.assign(this.options, options);
        }
        makeAutoObservable(this);
    }
    Object.defineProperty(BasePaginationState.prototype, "currentPage", {
        get: function () { return this.options.currentPage; },
        set: function (n) { this.options.currentPage = n; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePaginationState.prototype, "lastPage", {
        get: function () { return Math.ceil(this.totalItems / this.perPage); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePaginationState.prototype, "perPage", {
        get: function () { return this.options.perPage; },
        set: function (n) { this.options.perPage = n; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePaginationState.prototype, "doNotSyncWithURL", {
        get: function () { var _a; return (_a = this.options.doNotSyncWithURL) !== null && _a !== void 0 ? _a : false; },
        set: function (v) { this.options.doNotSyncWithURL = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePaginationState.prototype, "totalItems", {
        get: function () { return this.options.totalItems; },
        set: function (n) { this.options.totalItems = n; },
        enumerable: false,
        configurable: true
    });
    return BasePaginationState;
}());
export default BasePaginationState;
